export default __webpack_public_path__ + "static/media/landing-identity.1cc978d4.webp";